var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPadlock(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.988 8.029H10.86V5.624c0-2.33-1.916-4.247-4.246-4.247-2.33 0-4.246 1.917-4.246 4.247v2.405H1.24V5.624A5.373 5.373 0 016.614.25a5.373 5.373 0 015.374 5.374v2.405z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.424 18.25h-9.62A1.829 1.829 0 010 16.447V9.23c0-.977.827-1.803 1.804-1.803h9.62c.977 0 1.804.826 1.804 1.803v7.216a1.804 1.804 0 01-1.804 1.803zm-9.62-9.62a.594.594 0 00-.601.601v7.216c0 .338.263.6.6.6h9.62a.594.594 0 00.602-.6V9.23a.594.594 0 00-.601-.6h-9.62z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.816 11.035c0 .676-.526 1.203-1.202 1.203a1.187 1.187 0 01-1.203-1.203c0-.676.526-1.202 1.203-1.202a1.21 1.21 0 011.202 1.202z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.914 11.035h-.601l-.601 3.607h1.804l-.602-3.607z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPadlock);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "assets/iconPadlock.ec6c89ee.svg";
export { MemoForwardRef as ReactComponent };